var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center"},[(this.value)?_c('b-badge',{staticClass:"w-75 size",attrs:{"variant":_vm.sizeIndicator(this.value)}},[_vm._v(_vm._s(_vm.formatBytes(this.value))+"\n  ")]):_c('span',[_vm._v("N/A")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }